import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import AuthGuard from "../components/auth/AuthGaurd";
import AdminGuard from "../components/auth/AdminGuard";
import ManagerGuard from "../components/auth/ManagerGuard";
import RoleHomeRedirect from "../components/auth/RoleHomeRedirect";
import Add_Merchant from "../components/merchant/add-merchant";
import Merchant_list from "../components/merchant/merchant-list";
import EditMerchant from "../components/merchant/edit-merchant";
import PushCampaigns from "../components/marketing/push-campaigns";
import AppBanners from "../components/marketing/app-banners";
import BranchesList from "../components/branches/branchesList";
import EditBranch from "../components/branches/edit-branch";
import CompaniesList from "../components/settings/company/companyList";
import EditCompanyConfiguration from "../components/settings/editCompanyConfiguration";
import AddBranch from "../components/branches/add-branch";
import List_user1 from "../components/merchant/userstore";
import UserStore from "../components/merchant/userstore";
import Add_Article from "../components/article/add-article";
import Article_list from "../components/article/article-list";
import EditArticle from "../components/article/edit-article";
import Add_Reward from "../components/rewards/add-reward";
import Reward_list from "../components/rewards/reward-list";
import EditReward from "../components/rewards/edit-reward";
import Devices_list from "../components/devices/devices-list";
import PromotionList from "../components/promotion/promotion-list";
import AddPromotion from "../components/promotion/add-promotion";
import EditPromotion from "../components/promotion/edit-promotion";
import ModifiersPage from "../components/products/physical/modifiers";
import ModifierCategoriesPage from "../components/products/physical/modifier-category";
import EditUser from "../components/users/edit-user";
import AddUser from "../components/users/add-user";
import ListCoupons from "../components/coupons/list-coupons";
import Createcoupons from "../components/coupons/create-coupons";
import CreateOrder from "../components/sales/create-order";
import Cart from "../components/sales/Cart";
import Feedback from "../components/sales/Feedback";
import FeedbackSubjectList from "../components/sales/FeedbackSubjectList";
import DeliveryCancelledOrders from "../components/sales/delivery-cancelled-orders";
import StuckOrders from "../components/sales/stuck-orders";
import Payments from "../components/sales/payments";
import TelrSessions from "../components/sales/telr-sessions";
import MoyasarMerchants from "../components/sales/moyasar-merchants";
import MoyasarPlatformPage from "../components/merchant/moyasar-platform";
import DraftOrders from "../components/sales/draft-orders";
import OrderRejections from "../components/sales/order-rejections";
import MenuLogs from "../components/merchant/menu-logs";
import SmsSettings from "../components/merchant/sms-settings";
import SmsUsage from "../components/reporting/sms-usage";
import WalletSettings from "../components/wallet/wallet-settings";
import WalletReport from "../components/wallet/wallet-report";
import BuzzerIntegration from "../components/merchant/buzzer-integration";
import GoogleBusiness from "../components/merchant/google-business";
import EmailSettings from "../components/merchant/email-settings";
import ReceiptLayoutPage from "../components/merchant/receipt-layout/receipt-layout";
import DeliverectLocationsPage from "../components/merchant/deliverect-locations/deliverect-locations";
import SupportUsers from "../components/merchant/support-users";
import Loyalty from "../components/merchant/loyalty-list";
import Add_Loyalty from "../components/merchant/add-loyalty";
import Edit_Loyalty from "../components/merchant/edit-loyalty";
import LoyaltyLedger from "../components/merchant/ledger";
import Vouchers from "../components/merchant/vouchers";
import Coupons from "../components/offers/coupons";
import WalletPasses from "../components/loyalty/wallet-passes";
import LoyaltyCardDesign from "../components/loyalty/card-design";
import RedeemedRewards from "../components/merchant/redeemed-reweards";
import PosLoyaltyReturns from "../components/merchant/pos-loyalty-returns";
import EditProductMenu from "../components/products/physical/edit-product-menu";
import SqlRunner from "../components/sql-runner/SqlRunner";
import CronJobs from "../components/system/cron-jobs";
import AppsList from "../components/apps/apps-list";
import EditApp from "../components/apps/edit-app";
import BrandsList from "../components/brands/BrandsList";
import Recommendations from "../components/recommendations/recommendations";
import CustomerFeedbackList from "../components/feedback/CustomerFeedbackList";
import ShortLinkList from "../components/url-shortener/short-link-list";
import EditShortLink from "../components/url-shortener/edit-short-link";
import TableList from "../components/table-management/tables/table-list";
import ReservationList from "../components/reservations/reservation-list";
import AddReservation from "../components/reservations/add-reservation";
import EditReservation from "../components/reservations/edit-reservation";
import WaitlistList from "../components/table-management/waitlist/waitlist-list";
import ArrivalsList from "../components/arrivals/arrivals-list";
import AddWaitlist from "../components/table-management/waitlist/add-waitlist";
import EditWaitlist from "../components/table-management/waitlist/edit-waitlist";
import WaitlistAnalytics from "../components/table-management/waitlist/waitlist-analytics";
import WaitlistStaff from "../components/table-management/waitlist/waitlist-staff";
import Waiters from "../components/table-management/waiters/waiters-list";
import ApiKeyList from "../components/api-keys/api-key-list";
import KdsDeviceList from "../components/kds-devices/kds-device-list";
import NotificationList from "../components/notifications/notification-list";
import TableDashboard from "../components/table-management/dashboard/table-dashboard";
import DriveThruSetup from "../components/drive-thru/DriveThruSetup";
import AnprEvents from "../components/drive-thru/AnprEvents";
import PickupBlockSetup from "../components/pickup-block/PickupBlockSetup";
import VehicleMasterData from "../components/vehicles/VehicleMasterData";
import PlateSearch from "../components/vehicles/PlateSearch";
import ReservationCalendar from "../components/reservations/reservation-calendar";
import SnoozedProducts from "../components/products/physical/snoozed-products";
import HiddenModifiers from "../components/products/physical/hidden-modifiers";
import SystemProductList from "../components/products/physical/system-product-list";
import EditSystemProduct from "../components/products/physical/edit-system-product";
import SaleOrderList from "../components/sale-orders/sale-order-list";
import SystemProductCategories from "../components/products/physical/system-product-categories";
import AssignSystemProducts from "../components/products/physical/assign-system-products";
import ContactMessages from "../components/contact/contact-messages";
import ProductMasterData from "../components/products/physical/product-master-data";
import ProductTemplates from "../components/products/physical/product-templates";
import CustomerLoyaltyPage from "../components/reporting/CustomerLoyaltyPage";
import CustomerDetailPage from "../components/reporting/CustomerDetailPage";
import ProductPerformancePage from "../components/reporting/ProductPerformancePage";
import CustomerAreasPage from "../components/reporting/CustomerAreasPage";
import StepPickupAnalyticsPage from "../components/reporting/StepPickupAnalyticsPage";
import ScreenList from "../components/digital-signage/screen-list";
import ScreenConfigure from "../components/digital-signage/screen-configure";
import TerminalList from "../components/payment-terminals/terminal-list";
import AboutUsValues from "../components/about-us/about-us-values";
import PagesList from "../components/pages/PagesList";
import PageEditor from "../components/pages/PageEditor";
import MediaLibrary from "../components/media/MediaLibrary";
import MembershipTypeList from "../components/membership/membership-type-list";
import MembershipTypeForm from "../components/membership/membership-type-form";
import MembershipGroupList from "../components/membership/membership-group-list";
import MembershipGroupForm from "../components/membership/membership-group-form";
import MembershipList from "../components/membership/membership-list";
import MemberProfile from "../components/membership/member-profile";
import MembershipActivity from "../components/membership/membership-activity";
import MembershipAnalyticsPage from "../components/reporting/MembershipAnalyticsPage";


const FullLayout = lazy(() => import("../components/layout/FullLayout"));
const BlankLayout = lazy(() => import("../components/layout/BlankLayout"));

const Dashboard = lazy(() => import("../components/dashboard/dashboard"));
const Addproduct = lazy(() =>
  import("../components/products/physical/add-product")
);
const Category = lazy(() => import("../components/products/physical/category"));
const AppCategory = lazy(() => import("../components/products/physical/app-category"));
const EditProduct = lazy(() =>
  import("../components/products/physical/edit-product")
);
const Productlist = lazy(() =>
  import("../components/products/physical/product-list")
);
const AddProductMenu = lazy(() =>
  import("../components/products/physical/add-product-menu")
);
const ProductMenuList = lazy(() =>
  import("../components/products/physical/product-menu-list")
);
const Orders = lazy(() => import("../components/sales/orders"));
const Listuser = lazy(() => import("../components/users/list-user"));
const ImportCustomers = lazy(() => import("../components/users/import-customers"));

const Error = lazy(() => import("../components/auth/Error"));
const Login = lazy(() => import("../components/auth/login"));

const Router = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <FullLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/", element: <RoleHomeRedirect /> },
      { path: "/dashboard", exact: true, element: <ManagerGuard><Devices_list /></ManagerGuard> },
      // { path: "/products/category", exact: true, element: <Category /> },
      // { path: "/products/modifier", exact: true, element: <ModifiersPage /> },
      // { path: "/products/modifier-category", exact: true, element: <ModifierCategoriesPage /> },
      { path: "/products/product-list", exact: true, element: <Productlist /> },
      { path: "/products/product-templates", exact: true, element: <ProductTemplates /> },
      { path: "/products/app-categories", exact: true, element: <AppCategory /> },
      // {
      //   path: "/product/edit-product/:productId",
      //   exact: true,
      //   element: <EditProduct />,
      // },
      { path: "/products/add-product-menu", exact: true, element: <AddProductMenu /> },
      {
        path: "/products/edit-product-menu/:menuId",
        exact: true,
        element: <EditProductMenu />, // Should be EditProductMenu, but using Add for now
      },
      { path: "/products/product-menu-list", exact: true, element: <ProductMenuList /> },
      { path: "/products/snoozed-products", exact: true, element: <SnoozedProducts /> },
      { path: "/products/hidden-modifiers", exact: true, element: <HiddenModifiers /> },
      { path: "/products/system-product-list", exact: true, element: <SystemProductList /> },
      { path: "/products/edit-system-product/:productId", exact: true, element: <EditSystemProduct /> },
      { path: "/products/system-product-categories", exact: true, element: <SystemProductCategories /> },
      { path: "/products/assign-system-products", exact: true, element: <AssignSystemProducts /> },
      { path: "/merchant/contact-messages", exact: true, element: <ContactMessages /> },
      { path: "/products/master-data", exact: true, element: <ProductMasterData /> },

      // offers
      // /offers/coupons is now served by the new Coupons component below.
      // { path: "/offers/coupons", exact: true, element: <ListCoupons /> },
      { path: "/offers/create-coupon", exact: true, element: <Createcoupons /> },



      // { path: "/products/add-product", exact: true, element: <Addproduct /> },
      { path: "/settings/companiesList", exact: true, element: <CompaniesList /> },
      { path: "/settings/editCompanyConfiguration/:companyID", exact: true, element: <EditCompanyConfiguration /> },
      { path: "/Orders/Orders", exact: true, element: <Orders /> },
      // { path: "/orders/create-order", exact: true, element: <CreateOrder /> },
      { path: "/orders/delivery-cancelled-order", exact: true, element: <DeliveryCancelledOrders /> },
      { path: "/Orders/StuckOrders", exact: true, element: <StuckOrders /> },
      { path: "/Orders/Payments", exact: true, element: <Payments /> },
      { path: "/Orders/TelrSessions", exact: true, element: <TelrSessions /> },
      // Moyasar Platform onboarding — system admin only (the API refuses everyone else too).
      { path: "/merchant/moyasar-merchants", exact: true, element: <AdminGuard><MoyasarMerchants /></AdminGuard> },
      { path: "/merchant/moyasar-platform/:merchantID", exact: true, element: <AdminGuard><MoyasarPlatformPage /></AdminGuard> },
      { path: "/Orders/DraftOrders", exact: true, element: <DraftOrders /> },
      { path: "/Orders/OrderRejections", exact: true, element: <OrderRejections /> },
      { path: "/Orders/Feedback", exact: true, element: <Feedback /> },
      { path: "/Orders/FeedbackSubjects", exact: true, element: <FeedbackSubjectList /> },
      { path: "/orders/cart", exact: true, element: <Cart /> },
      { path: "/users/list-user", exact: true, element: <Listuser /> },
      { path: "/users/add-user", exact: true, element: <AdminGuard><AddUser /></AdminGuard> },
      { path: "/users/import-customers", exact: true, element: <AdminGuard><ImportCustomers /></AdminGuard> },
      { path: "/users/edit-user/:userId", exact: true, element: <EditUser /> },

      //articles
      // { path: "/article/add-article", exact: true, element: <Add_Article /> },
      // { path: "/article/article-list", exact: true, element: <Article_list /> },
      // {
      //   path: "/article/edit-article/:articleId",
      //   exact: true,
      //   element: <EditArticle />,
      // },
      //devices
      { path: "/devices/devices-list", exact: true, element: <Devices_list /> },
      //promotions
      { path: "/promotion/promotion-list", exact: true, element: <PromotionList /> },
      { path: "/promotion/add-promotion", exact: true, element: <AddPromotion /> },
      { path: "/promotion/edit-promotion/:promotionId", exact: true, element: <EditPromotion /> },
      //rewards
      { path: "/rewards/add-reward", exact: true, element: <Add_Reward /> },
      { path: "/rewards/reward-list", exact: true, element: <Reward_list /> },
      {
        path: "/rewards/edit-reward/:rewardId",
        exact: true,
        element: <EditReward />,
      },

      // Merchants
      { path: "/merchant/add-merchant", exact: true, element: <AdminGuard><Add_Merchant /></AdminGuard> },
      { path: "/merchant/merchant-list", exact: true, element: <Merchant_list /> },
      // Percentage tiers are configured inside the loyalty program form
      // (/merchant/add-loyalty and /merchant/edit-loyalty) when loyaltyType is
      // "percentage". The old standalone tier page and its /api/merchantbasetier
      // endpoints have been removed.
      { path: "/merchant/menu-logs", exact: true, element: <MenuLogs /> },
      { path: "/merchant/sms-settings", exact: true, element: <AdminGuard><SmsSettings /></AdminGuard> },
      { path: "/merchant/sms-usage", exact: true, element: <AdminGuard><SmsUsage /></AdminGuard> },
      // Customer wallet (stored value) — NOT the "Wallet Passes" pages, which are Apple Wallet.
      // Settings is AdminGuard-wrapped because it configures money limits; the report is not,
      // so merchant users can see their own liability and adjust their own customers. Both are
      // enforced server-side regardless — AdminGuard only decides what renders.
      { path: "/wallet/settings", exact: true, element: <AdminGuard><WalletSettings /></AdminGuard> },
      { path: "/wallet/report", exact: true, element: <WalletReport /> },
      { path: "/merchant/buzzer-integration", exact: true, element: <AdminGuard><BuzzerIntegration /></AdminGuard> },
      { path: "/merchant/google-business", exact: true, element: <AdminGuard><GoogleBusiness /></AdminGuard> },
      { path: "/merchant/email-settings", exact: true, element: <EmailSettings /> },
      { path: "/merchant/receipt-layout", exact: true, element: <ReceiptLayoutPage /> },
      { path: "/merchant/deliverect-locations", exact: true, element: <DeliverectLocationsPage /> },
      { path: "/merchant/support-users", exact: true, element: <AdminGuard><SupportUsers /></AdminGuard> },
      { path: "/merchant/loyalty", exact: true, element: <Loyalty /> },
      { path: "/merchant/add-loyalty", exact: true, element: <Add_Loyalty /> },
      { path: "/merchant/edit-loyalty/:loyaltyId", exact: true, element: <Edit_Loyalty /> },
      { path: "/merchant/loyalty-ledger", exact: true, element: <LoyaltyLedger /> },
      { path: "/loyalty/vouchers", exact: true, element: <Vouchers /> },
      { path: "/offers/coupons", exact: true, element: <Coupons /> },
      { path: "/loyalty/wallet-passes", exact: true, element: <WalletPasses /> },
      { path: "/loyalty/card-design", exact: true, element: <LoyaltyCardDesign /> },
      { path: "/loyalty/redeemed-rewards", exact: true, element: <RedeemedRewards /> },
      { path: "/loyalty/pos-returns", exact: true, element: <PosLoyaltyReturns /> },

      // Marketing push campaigns — admin and merchant users; operations is bounced by
      // OPERATIONS_ALLOWED_PATHS and refused server-side on every write.
      { path: "/marketing/push-campaigns", exact: true, element: <PushCampaigns /> },
      { path: "/marketing/app-banners", exact: true, element: <AppBanners /> },

      // Membership. The tier form serves both routes — see membership-type-form.js for why
      // it is one component rather than the add/edit pair used elsewhere in this repo.
      // No delete route exists anywhere: a tier is retired by deactivating it and a card is
      // stopped by a status change, both of which keep the row and its history.
      { path: "/membership/types", exact: true, element: <MembershipTypeList /> },
      { path: "/membership/types/add", exact: true, element: <MembershipTypeForm /> },
      { path: "/membership/types/edit/:id", exact: true, element: <MembershipTypeForm /> },
      // Companies. The form serves both routes — see membership-group-form.js for why.
      { path: "/membership/companies", exact: true, element: <MembershipGroupList /> },
      { path: "/membership/companies/add", exact: true, element: <MembershipGroupForm /> },
      { path: "/membership/companies/edit/:id", exact: true, element: <MembershipGroupForm /> },
      { path: "/membership/members", exact: true, element: <MembershipList /> },
      { path: "/membership/members/:id", exact: true, element: <MemberProfile /> },
      { path: "/membership/activity", exact: true, element: <MembershipActivity /> },
      { path: "/reporting/membership", exact: true, element: <MembershipAnalyticsPage /> },

      {
        path: "/merchant/edit-merchant/:merchantID",
        exact: true,
        element: <AdminGuard><EditMerchant /></AdminGuard>,
      },
      {
        path: "/merchant/user-store/:merchantID",
        exact: true,
        element: <UserStore />,
      },
      {
        path: "/loyalty/user-store",
        exact: true,
        element: <UserStore />,
      },
      //branches
      { path: "/branches/branchesList", exact: true, element: <BranchesList /> },
      {
        path: "/branches/edit-branch/:branchID",
        exact: true,
        element: <EditBranch />,
      },
      // { path: "/branches/add-branch", exact: true, element: <AddBranch /> },

      // Table Management
      { path: "/table-management/dashboard", exact: true, element: <TableDashboard /> },
      { path: "/table-management/tables", exact: true, element: <TableList /> },

      // Drive-Thru ANPR
      { path: "/drive-thru/setup", exact: true, element: <DriveThruSetup /> },
      { path: "/drive-thru/events", exact: true, element: <AnprEvents /> },

      // Pickup Blocks
      { path: "/pickup-block/setup", exact: true, element: <PickupBlockSetup /> },
      // Car master data is global across merchants, so it is platform-admin only.
      { path: "/vehicles/master-data", exact: true, element: <AdminGuard><VehicleMasterData /></AdminGuard> },
      // Plate search is merchant-scoped, so any panel user may reach it.
      { path: "/vehicles/plate-search", exact: true, element: <PlateSearch /> },
      // Curbside / drive-thru: who is waiting in a car right now, across branches.
      { path: "/orders/arrivals", exact: true, element: <ArrivalsList /> },
      { path: "/table-management/waitlist", exact: true, element: <WaitlistList /> },
      { path: "/table-management/add-waitlist", exact: true, element: <AddWaitlist /> },
      { path: "/table-management/edit-waitlist/:waitlistId", exact: true, element: <EditWaitlist /> },
      { path: "/table-management/waitlist-analytics", exact: true, element: <WaitlistAnalytics /> },
      { path: "/table-management/waitlist-staff", exact: true, element: <ManagerGuard><WaitlistStaff /></ManagerGuard> },
      { path: "/table-management/waiters", exact: true, element: <ManagerGuard><Waiters /></ManagerGuard> },

      // Reservations
      { path: "/reservations/list", exact: true, element: <ReservationList /> },
      { path: "/reservations/add", exact: true, element: <AddReservation /> },
      { path: "/reservations/edit/:reservationId", exact: true, element: <EditReservation /> },
      { path: "/reservations/calendar", exact: true, element: <ReservationCalendar /> },

      // API Keys
      { path: "/api-keys/list", exact: true, element: <AdminGuard><ApiKeyList /></AdminGuard> },

      // KDS Devices (pairing + online/off) — available to admin and merchant
      { path: "/kds-devices/list", exact: true, element: <KdsDeviceList /> },

      // Notifications
      { path: "/notifications", exact: true, element: <NotificationList /> },

      // Reporting
      { path: "/reporting/customer-loyalty", exact: true, element: <CustomerLoyaltyPage /> },
      { path: "/reporting/customer-detail/:customerId", exact: true, element: <CustomerDetailPage /> },
      { path: "/reporting/product-performance", exact: true, element: <ProductPerformancePage /> },
      { path: "/reporting/customer-areas", exact: true, element: <CustomerAreasPage /> },
      { path: "/reporting/steppickup-analytics", exact: true, element: <StepPickupAnalyticsPage /> },

      // Sale Orders
      { path: "/sale-orders/list", exact: true, element: <SaleOrderList /> },

      // Admin SQL Runner
      { path: "/admin/sql-runner", exact: true, element: <AdminGuard><SqlRunner /></AdminGuard> },
      { path: "/admin/cron-jobs", exact: true, element: <AdminGuard><CronJobs /></AdminGuard> },

      // About Us Page 
      {
        path: "/about-us",
        exact: true,
        element: <AboutUsValues />,
      },

      // Pages: per-merchant public documents (privacy policy, terms…). Operations sees them read-only.
      { path: "/pages", exact: true, element: <PagesList /> },
      { path: "/pages/new", exact: true, element: <PageEditor /> },
      { path: "/pages/:id", exact: true, element: <PageEditor /> },

      // Media: image library with permanent public links. Operations lists and copies only.
      { path: "/media", exact: true, element: <MediaLibrary /> },

      // Apps
      { path: "/apps/list", exact: true, element: <AdminGuard><AppsList /></AdminGuard> },
      { path: "/apps/add", exact: true, element: <AdminGuard><EditApp /></AdminGuard> },
      { path: "/apps/edit/:appId", exact: true, element: <AdminGuard><EditApp /></AdminGuard> },

      // Brands (per-merchant consumer brands, merchant-scoped so no AdminGuard)
      { path: "/brands/list", exact: true, element: <BrandsList /> },
      // Recommendation rails — merchant-scoped (operations read-only), so no AdminGuard.
      { path: "/recommendations", exact: true, element: <Recommendations /> },
      { path: "/feedback/list", exact: true, element: <CustomerFeedbackList /> },

      // App Links / QR (Diawi-style short links)
      { path: "/short-links", exact: true, element: <AdminGuard><ShortLinkList /></AdminGuard> },
      { path: "/short-links/edit/:id", exact: true, element: <AdminGuard><EditShortLink /></AdminGuard> },

      // Digital Signage
      { path: "/signage/screens", exact: true, element: <ScreenList /> },
      { path: "/signage/screens/configure/:screenId", exact: true, element: <ScreenConfigure /> },

      // Payment terminals (merchant-level registry a screen borrows from)
      { path: "/settings/payment-terminals", exact: true, element: <TerminalList /> },

    ],
  },
  {
    path: "/auth",
    element: <BlankLayout />,
    children: [{ path: "/auth/login", element: <Login /> }],
  },
  { path: "*", element: <Error /> },
];

export default Router;
